import type { CallParticipant } from '../../hooks/useCallParticipants';
import { type AppDispatch, type RootState } from '../../stores/redux';
import { getLegacyIdForMember } from '../realtime/realtime.selectors';
import { removePendingParticipant } from './session.slice';

export function removeParticipantFromPending(
  participantId: string,
  dispatch: AppDispatch,
  getState: () => RootState,
): void {
  dispatch(removePendingParticipant(participantId));

  const participantLegacyId = getLegacyIdForMember(getState(), participantId);
  if (participantLegacyId !== undefined) {
    dispatch(removePendingParticipant(participantLegacyId));
  }
}

/**
 * Determines if a participant video enabled or not. It could be published (hasVideo) but still
 * disabled (videoDisabledReason).
 */
export function isParticipantVideoEnabled(
  participant: CallParticipant,
): boolean {
  return participant.hasVideo && !participant.videoDisabledReason;
}
